import React from 'react';
import GridViewIcon from '@mui/icons-material/GridView';
import SplitscreenIcon from '@mui/icons-material/Splitscreen';
import ListIcon from '@mui/icons-material/ViewHeadline';
import { IconButton, useMediaQuery, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import TablePaginator from '../../../../../components/TablePaginator/TablePaginator';
import { ActionWithPayload } from '../../../../../utils/action-helper';
import { SortType } from '../../../../../interfaces/productType';
import { ILocation } from '../../../../../interfaces/locations';
import { IProductFilter } from '../../../../../interfaces/product';
import { IAppState } from '../../../../../store/rootDuck';

interface ProducCatalogHeader {
  classes: any;
  fetch: (payload: {
    page: number;
    perPage: number;
    filter?: IProductFilter;
    search?: string;
    categoryId?: number;
    sort_type?: string;
    locale?: ILocation | null;
    activity?: string;
    sortType?: SortType;
  }) => any;
  page: number;
  products: any[];
  perPage: number;
  total: number;
  selectedCategoryId: number | null;
  viewType: string;
  setViewType: (
    payload: 'table' | 'grid' | 'list'
  ) => ActionWithPayload<'products-catalog/SET_VIEWTYPE', 'table' | 'grid' | 'list'>;
  isAdmin: boolean | undefined;
  beforeFetch?: () => void;
}

const ProductCatalogHeader = React.memo(
  ({
    classes,
    fetch,
    page,
    products,
    perPage,
    total,
    selectedCategoryId,
    setViewType,
    viewType,
    isAdmin,
    beforeFetch,
  }: ProducCatalogHeader) => {
    const searchText = useSelector((state: IAppState) => state.productsCatalog.search) ?? '';
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
      <div className={classes.productColHeader}>
        <div className={classes.productColHeaderItem}>
          <IconButton
            onClick={() => setViewType('grid')}
            color={viewType === 'grid' ? 'primary' : 'inherit'}
            style={{
              color: viewType === 'grid' ? '#006997' : '#7c97c0',
            }}
          >
            <GridViewIcon style={{ width: 25, height: 25 }} />
          </IconButton>
          <IconButton
            onClick={() => setViewType('table')}
            color={viewType === 'table' ? 'primary' : 'inherit'}
            style={{
              color: viewType === 'table' ? '#006997' : '#7c97c0',
            }}
          >
            <SplitscreenIcon style={{ width: 21, height: 21 }} />
          </IconButton>
          {!isMobile && (
            <IconButton
              onClick={() => setViewType('list')}
              color={viewType === 'list' ? 'primary' : 'inherit'}
              style={{
                color: viewType === 'list' ? '#006997' : '#7c97c0',
              }}
            >
              <ListIcon style={{ width: 25, height: 25 }} />
            </IconButton>
          )}
        </div>
        <div className={classes.productColHeaderItem} style={{ width: '100%' }}>
          {fetch && (
            <TablePaginator
              id={+''}
              page={page || 1}
              realPerPage={products.length}
              perPage={perPage || 10}
              total={total || 0}
              fetchRows={(props: any) => {
                fetch({ categoryId: selectedCategoryId, search: searchText, ...props });
                beforeFetch?.();
              }}
              rowsPerPageOptions={[10, 50, 100]}
            />
          )}
        </div>
      </div>
    );
  }
);

export default ProductCatalogHeader;
